import type {DesignSelectorPanelProps} from '@Panels/design-selector-panel/design-selector-panel';

export type DesignSelectorModalProps = DesignSelectorPanelProps;

export const PANEL_ID = 'design-selector-panel';
export const DESIGN_SELECTOR_MODAL_HEIGHT = '95%';
export const DESIGN_SELECTOR_MODAL_WIDTH = '100%';
